import React, { useEffect, useRef, useState} from "react";
import {
    PageArticleWrap,
    PageHeaderTitleButtonStyle,
} from "components/layout/Layout";
import {
    CommonResult,
    PasswordChangeType,
    SingleResult, SiteShortInfo,
    UserInfo,
    UserRequestType,
    UserShortInfo
} from "../../type/type";
import Loading from "components/Loading";
import {checkLoginIdPw, deleteUserHandler, getImageUrl, getSmsAuthCommonRequest, getSmsAuthVerify, getUserInfo, updatePassword, updateUserHandler} from "../../api/api";
import {NoLinePrimaryBtn, NoLineRedBtn, OutlinePrimaryBtn, SolidPrimarySubBtn } from "components/button/Button";
import styled from "styled-components";
import {aesCBCDecrypt, aesCBCEncrypt, handleImageUpload, ROLE_DIRECTOR, ROLE_TEACHER} from "../../utils/commonUtils";
import DefaultProfileS from "../../assets/image/common/default_profile_S.svg";
import { FlexWrapC, FlexWrapR, InputWrapC, InputWrapR } from "components/common/CommonLayout";
import {useLoginUserInfo} from "../../redux/hook/useLoginUserInfo";
import { colors } from "styles/global-styles";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { selectSiteIdState, userRoleState } from "styles/atoms";

const MenuToggleWrap = styled.div`
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
    
    .active {
        color: ${({ theme }) => theme.newTheme.default.primary};
    }
    p {
        font-size: 0.875rem;
    }
`;

//left content
const RowContentLeftWrap = styled.div`
    width: 20%;

    .file-wrap {
        width:100%;
        justify-content: center;
    }
`;

//right content
const RowContentRightWrap = styled.div`
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem 0.25rem;

    input {
        width: 100%;
    }
    // 회원탈퇴 버튼
    .delete_id_btn {
        margin-top: 2rem;
        button {
            color: ${({ theme }) => theme.newTheme.border.redBd};
            &:hover {
                color: ${colors.red};
            }
        }
    }
`;

const ImageOneWrap = styled.div`
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  .preview-image {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
  } 
  .carema-icon {
    position: absolute;
    top: 75%;
    left: 70%;
  }  
  &:hover {
    cursor: pointer;
    img:not(.cancel-icon),
    label {
      opacity: 0.7;
    }
  }
`;

const InputStyle = styled.input`
    width: 100%;
    position: relative;
    padding-right: 3rem !important;

    ~ .eye-on-off {
        position: absolute;
        right: 1rem;
        &.delect-id-input {
            right: 4.5rem;
        }
    }
`;

/**
 * 최소 하나 이상의 영문자(대/소문자) + 최소 하나 이상의 숫자 + 최소 하나 이상의 특수문자로 이루어진 8 ~ 16자리 비밀번호
 */
const passwordRegex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*?_]).{8,16}$/;

const UserChangePwViewer = () => {

    const { user } = useLoginUserInfo();
    const { login_id } = user;

    // 비밀번호 입력
    const [passwordObj, setPasswordObj] = useState<PasswordChangeType>({
        login_id: login_id,
        current_password: "",
        new_password: "",
        new_password_confirm: ""
    });

    const [isPasswordOk, setIsPasswordOk] = useState(false);
    const [passwordErrorMsg, setPasswordErrorMsg] = useState("");

    // 비밀번호 입력값 보이기/가리기
    const [currentEyeOnOff, setCurrentEyeOnOff] = useState(false);
    const [newEyeOnOff1, setNewEyeOnOff1] = useState(false);
    const [newEyeOnOff2, setNewEyeOnOff2] = useState(false);

    //useState에 적용되는 시간이 있어서 비밀번호/비밀번호 확인에 대한 handler 따로 적용
    function handleChangePw(e: React.ChangeEvent<HTMLInputElement>) {
        const { value } = e.target;
        
        const isOk = passwordRegex.test(value);

        setPasswordObj(prev => ({ ...prev, new_password: value }));

        if (isOk) {
            if (value === passwordObj.new_password_confirm) {
                setPasswordErrorMsg("");
                setIsPasswordOk(true);
            }
            else {
                setPasswordErrorMsg("비밀번호를 다시 확인해주세요.");
                setIsPasswordOk(false);
            }
        }
        else {
            setPasswordErrorMsg("비밀번호는 최소 8자에서 16자까지, 영문자/숫자/특수 문자를 포함해야 합니다.");
            setIsPasswordOk(false);
        }
    }

    function handleChangePw2(e: React.ChangeEvent<HTMLInputElement>) {
        const { value } = e.target;
        
        const isOk = passwordRegex.test(value);

        setPasswordObj(prev => ({ ...prev, new_password_confirm: value }));

        if (isOk) {
            if (passwordObj.new_password === value) {
                setPasswordErrorMsg("");
                setIsPasswordOk(true);
            }
            else {
                setPasswordErrorMsg("비밀번호를 다시 확인해주세요.");
                setIsPasswordOk(false);
            }
        }
        else {
            setPasswordErrorMsg("비밀번호는 최소 8자에서 16자까지, 영문자/숫자/특수 문자를 포함해야 합니다.");
            setIsPasswordOk(false);
        }
    }

    // 비밀번호 변경
    async function changeUserPw() {
        if (!isPasswordOk || !passwordObj.current_password) return;

        try {
             //암호화
            const updateData = {
                login_id: passwordObj.login_id,
                current_password: aesCBCEncrypt(passwordObj.current_password),
                new_password: aesCBCEncrypt(passwordObj.new_password),
                new_password_confirm: aesCBCEncrypt(passwordObj.new_password_confirm),
            }
            const res = await updatePassword(updateData);

            if (res.code === 200) {
                alert("비밀번호가 변경되었습니다.");
                // 설정값 초기화
                setPasswordObj(prev => ({
                    ...prev,
                    current_password: "",
                    new_password: "",
                    new_password_confirm: "",
                }))
                setIsPasswordOk(false);
                setPasswordErrorMsg("");
                setCurrentEyeOnOff(false);
                setNewEyeOnOff1(false);
                setNewEyeOnOff2(false);
            }
            else {
                alert(res.message);
                return;
            }
        } catch (error) {
            console.error(error);
        }
    }

    function handleActiveEnter(e: any) {
        if (e.key === 'Enter') changeUserPw();
    }

    return (
        <>
            <FlexWrapC $gap="1.5rem" style={{paddingLeft: '1rem', width: '50%'}}>
                <InputWrapC>
                    <InputWrapR $alignItems="center">
                        <label htmlFor="currentPassword" style={{whiteSpace: "pre", width: '8.75rem'}}>현재 비밀번호</label>
                        <InputWrapR $alignItems="center">
                            <InputStyle
                                type={!currentEyeOnOff ? 'password' : 'text'}
                                name="currentPassword"
                                value={passwordObj.current_password}
                                onChange={(e) => setPasswordObj({...passwordObj, current_password: e.target.value})}
                                onKeyDown={handleActiveEnter}
                                maxLength={16}
                                placeholder="비밀번호 입력"
                            />
                            <div className='eye-on-off' onClick={() => setCurrentEyeOnOff(prev => !prev)}>
                                {!currentEyeOnOff ? <img src="/image/icon/eye_visible.svg" alt="eye_visible" /> : <img src="/image/icon/eye_invisible.svg" alt="eye_invisible" />}
                            </div>
                        </InputWrapR>
                    </InputWrapR>
                    <InputWrapR $alignItems="center">
                        <label htmlFor="new_password" style={{whiteSpace: "pre", width: '8.75rem'}}>신규 비밀번호</label>
                        <InputWrapR $alignItems="center">
                            <InputStyle
                                type={!newEyeOnOff1 ? 'password' : 'text'}
                                name="new_password"
                                value={passwordObj.new_password}
                                onChange={handleChangePw}
                                onKeyDown={handleActiveEnter}
                                maxLength={16}
                                placeholder="신규 비밀번호 입력(8~16자리/대소문자/숫자/특수문자 포함)"
                            />
                            <div className='eye-on-off' onClick={() => setNewEyeOnOff1(prev => !prev)}>
                                {!newEyeOnOff1 ? <img src="/image/icon/eye_visible.svg" alt="eye_visible" /> : <img src="/image/icon/eye_invisible.svg" alt="eye_invisible" />}
                            </div>
                        </InputWrapR>
                    </InputWrapR>
                    <InputWrapC>
                        <InputWrapR $alignItems="center">
                            <label htmlFor="new_password_confirm" style={{whiteSpace: "pre", width: '8.75rem'}}>신규 비밀번호 확인</label>
                            <InputWrapR $alignItems="center">
                                <InputStyle
                                    type={!newEyeOnOff2 ? 'password' : 'text'}
                                    name="new_password_confirm"
                                    value={passwordObj.new_password_confirm}
                                    onChange={handleChangePw2}
                                    onKeyDown={handleActiveEnter}
                                    maxLength={16}
                                    placeholder="신규 비밀번호 확인 입력(8~16자리/대소문자/숫자/특수문자 포함)"
                                />
                                <div className='eye-on-off' onClick={() => setNewEyeOnOff2(prev => !prev)}>
                                    {!newEyeOnOff2 ? <img src="/image/icon/eye_visible.svg" alt="eye_visible" /> : <img src="/image/icon/eye_invisible.svg" alt="eye_invisible" />}
                                </div>
                            </InputWrapR>
                        </InputWrapR>
                        <p className={`text-red ${(passwordObj.new_password_confirm && !isPasswordOk) ? "show" : "none"}`} style={{fontSize: '0.75rem'}}>{passwordErrorMsg}</p>
                    </InputWrapC>
                </InputWrapC>
                <SolidPrimarySubBtn onClick={changeUserPw} disabled={!(isPasswordOk && passwordObj.current_password) ? true : false} >확인</SolidPrimarySubBtn>
            </FlexWrapC>
        </>
    )
}

const UserInfoViewer = () => {

    // 전역 데이터
    const selectSiteId = useRecoilValue(selectSiteIdState);
    const user_role = useRecoilValue(userRoleState);

    const { access,user, userMainImageUrl, updateUserMainImageUrl,updateLoginUserInfo } = useLoginUserInfo();
    const { user_id } = access;
    const { login_id } = user;

    const imageInput = useRef<HTMLInputElement>(null);

    // 인증시간
    const MINUTES_IN_MS = 3 * 60 * 1000;
    const INTERVAL = 1000;
    const [leftTime, setLeftTime] = useState<number>(MINUTES_IN_MS);
    const [isFail, setIsFail] = useState(false);

    const mins = String(Math.floor((leftTime / (1000 * 60)) % 60)).padStart(2, "0");
    const sec = String(Math.floor((leftTime / 1000) % 60)).padStart(2, "0");

    const [loading, setLoading] = useState<boolean>(false);

    const defaultRequestUser: UserRequestType = {
        name: user.name, // 암호화 필요
        email: user.email || "", // 암호화 필요
        phone: user.phone, // 암호화 필요
        temp_phone: user.temp_phone || "", // 암호화 필요
        unique_code: user.unique_code || "", // 사용자 고유 코드 (단말기 사번)
        card_no: user.card_no || "",
        base64_list: [], //이미지 base64는 서버에 보내는 용도로만 사용 (display용도는 userMainImageUrl)
    };
    // 수정시에는 1개의 항목만 수정되어야 하기 때문에 기존 데이터 복사
    const copyDefaultRequestUser = JSON.parse(JSON.stringify(defaultRequestUser));

    //정보 수정 시 필요한 정보
    const [requestUser, setRequestUser] = useState<UserRequestType>(defaultRequestUser);

    // 이름 수정/취소 버튼
    const [nameUpdateBtn, setNameUpdateBtn] = useState(false);
    // 휴대폰 수정/취소 버튼
    const [phoneUpdateBtn, setPhoneUpdateBtn] = useState(false);
    // 이메일 수정/취소 버튼
    const [emailUpdateBtn, setEmailUpdateBtn] = useState(false);
    // 이미지 저장 버튼
    const [imageUpdateBtn, setImageUpdateBtn] = useState(false);

    // 담당반
    const [userTeamClass, setUserTeamClass] = useState("");

    // 받은 인증번호
    const [authNumber, setAuthNumber] = useState("");
    // 인증 버튼 클릭
    const [clickAuthBtn, setClickAuthBtn] = useState(false);

    // 입력한 인증번호
    const [authVerifyNumber, setAuthVerifyNumber] = useState("");

    // 회원탈퇴 관련
    const [showInput, setShowInput] = useState(false);
    const [loginUserObj, setLoginUserObj] = useState<{ login_id: string, login_pw: string }>({
        login_id: login_id, login_pw: ""
    });
    const [newEyeOnOff, setNewEyeOnOff] = useState(false);

    // 파일 선택 - input 클릭 시(사진)
    const handleImageFileClick = (e: any) => {
        imageInput.current?.click();
    };

    // 인증번호 입력
    function handleOnChange(e: any) {
        const { value } = e.target;
        if (isNaN(value)) setAuthVerifyNumber(authVerifyNumber);
        else setAuthVerifyNumber(value);
    }

    // 인증번호 요청
    const smsRequest = async () => {
        setClickAuthBtn(true);
        setAuthVerifyNumber(""); // input 초기화
        setLeftTime(MINUTES_IN_MS); // 3분 초기화
        setIsFail(false);

        // 이름/핸드폰번호 있어야 인증번호 전송
        const result: SingleResult<string> = await getSmsAuthCommonRequest({
            name: aesCBCDecrypt(user.name),
            phone: requestUser.phone,
            sms_type: "USER_INFO_CHANGE"
        });

        if (result.code === 200) setAuthNumber(result.data);
        else {
            alert(result.message);
            setAuthNumber("");
            setClickAuthBtn(false);
            setLeftTime(MINUTES_IN_MS); // 3분 초기화
            return;
        }
    };

    //사용자 기본정보 수정 handler
    function updateRequestUser(updates: Partial<UserRequestType>) {
        setRequestUser({
            ...requestUser,
            ...updates,
        });
    }

    //이름/이메일 값 변경 handler
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        updateRequestUser({ [name]: aesCBCEncrypt(value) }); // 상태 업데이트
    };
    //핸드폰 번호 변경 handler
    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name } = e.target;
        const value = e.target.value.replace(/\D/g, '');
        if (value.length <= 11) {
            updateRequestUser({ [name]: aesCBCEncrypt(value) }); // 상태 업데이트
        }
    };

    //사용자 기본정보 수정 API
    const updateUserInfo = async (type: string, data: UserRequestType) => {
        
        const res:CommonResult = await updateUserHandler(user_id, data);

        const updateValue =
            type === "name" ? data.name : type === "phone" ? data.phone : type === "email" ? data.email : data.base64_list;

        if (res.code === 200) {
            alert("수정되었습니다.");
            // 모든 수정/저장 버튼 초기화
            setNameUpdateBtn(false);
            setPhoneUpdateBtn(false);
            setEmailUpdateBtn(false);
            setImageUpdateBtn(false);
            // 인증 관련 초기화
            setClickAuthBtn(false);
            setAuthVerifyNumber(""); // input 초기화
            setIsFail(false);
            // 이미지 select 초기화
            cancleImageChange();
            // 탈퇴부분 초기화
            setShowInput(false);
            setLoginUserObj({...loginUserObj, login_pw: ""});
            setNewEyeOnOff(false);

            const newUser: UserInfo = {
                ...user,
                [type]: updateValue
            }
            updateLoginUserInfo(access, newUser, selectSiteId);
            setRequestUser({...defaultRequestUser, [type]: updateValue});
            getClassAndImage();
            return;
        }
        else {
            alert(res.message);
            return;
        }

    }

    //사용자 이름 수정
    const updateUserNameInfo = () => {
        const { name, ...rest } = requestUser;

        const newRequestUser = { ...copyDefaultRequestUser, name };
        updateUserInfo("name", newRequestUser);
    }

    //사용자 휴대폰번호 수정
    const updateUserPhoneInfo = async () => {
        const { phone, ...rest } = requestUser;

        // 인증이 완료되면 수정
        const result = await getSmsAuthVerify(phone, authVerifyNumber);
        
        if (result.code === 200) {
            const newRequestUser = { ...copyDefaultRequestUser, phone };
            updateUserInfo("phone", newRequestUser);
        }
        else if (result.code === 400) {
          alert("인증번호가 일치하지 않습니다.");
          return;
        }
        else {
          alert(result.message);
          return;
        }

    }

    //사용자 이메일 수정
    const updateUserEmailInfo = () => {
        const { email, ...rest } = requestUser;

        const newRequestUser = { ...copyDefaultRequestUser, email: email ? email : "" };
        updateUserInfo("email", newRequestUser);
    }

    //사용자 이미지 수정
    const updateUserImageInfo = () => {
        const { base64_list, ...rest } = requestUser;

        const newRequestUser = { ...copyDefaultRequestUser, base64_list };
        updateUserInfo("base64_list", newRequestUser);
    }

    //이미지 파일 변경 이벤트
    const onImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const base64Files:string[]|undefined = await handleImageUpload(event);
        if (base64Files && base64Files.length > 0) {
            setBase64Image(base64Files[0]);
        }
    };

    const setBase64Image = (base64: string) => {
        //이미지는 1개만 등록할수 있게, 배열 초기화 후 추가
        setRequestUser({
            ...requestUser,
            base64_list: [...[], base64]
        });
        setImageUpdateBtn(true);
    };

    // 사용자 이미지 수정 취소
    const cancleImageChange = () => {
        setRequestUser({...requestUser, base64_list: []});
    }

    //사용자의 이미지 + 선생님인 경우 담당반
    async function getClassAndImage() {
        try {
            setLoading(true);

            const res:SingleResult<UserShortInfo> = await getUserInfo(user_id);

            if (res.code === 200) {
                
                const siteList:SiteShortInfo[] = res.data.site_list.filter(s => s.id === selectSiteId);

                // 선생님인 경우 담당반 표시
                if (user_role === ROLE_TEACHER) {
                    const classList = (siteList && siteList.length) ? siteList[0].class_list : [];
                    if (classList.length) setUserTeamClass(classList[0].name);
                    else setUserTeamClass("");
                }

                // 이미지 저장
                let imageUrl = '';
                if (res.data.image_file_name) {
                    imageUrl = getImageUrl(res.data.image_file_name);
                }
                else {
                    imageUrl = DefaultProfileS;
                }
                //사용자 메인 이미지 업데이트
                updateUserMainImageUrl(imageUrl);
            }
            else {
                alert(res.message);
                return;
            }

        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    // 회원탈퇴를 위한 비밀번호 입력
    const handlePwChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setLoginUserObj({...loginUserObj, login_pw: value});
    };
    const navigate = useNavigate();
    function handleActiveEnter(e: any) {
        if (e.key === 'Enter') handleDelectId();
    }
    // 탈퇴 버튼
    const handleDelectId = async () => {
        
        if (!window.confirm("정말 탈퇴하시겠습니까?")) {
            return;
        }
        if (!window.confirm("탈퇴 시 계정은 삭제되며 복구되지 않습니다. 그래도 탈퇴퇴하시겠습니까?")) {
            return;
        }

        // 비밀번호 확인
        const prop = { ...loginUserObj, login_pw: aesCBCEncrypt(loginUserObj.login_pw) };
        const isRigthPw = await checkLoginIdPw(prop);

        if (isRigthPw.code === 200) {

            // 회원탈퇴
            const deleteRes = await deleteUserHandler(user_id);

            // 탈퇴 성공, 로그인페이지로 이동
            if (deleteRes.code === 200) {
                navigate('/login');
            }
            else {
                alert(deleteRes.message);
                return;
            }
        }
        else {
            alert(isRigthPw.message);
            return;
        }

    }

    // 인증 버튼을 누르면 INTERVAL 마다 실행
    useEffect(() => {
        if (!clickAuthBtn) return;

        const timer = setInterval(() => {
            setLeftTime((prev) => prev - INTERVAL);
        }, INTERVAL);
        if (leftTime <= 0) {
            clearInterval(timer);
            setIsFail(true);
            setClickAuthBtn(false);
        }
        return () => {
            clearInterval(timer);
        };
    }, [clickAuthBtn, leftTime]);
    
    useEffect(() => {
        if (!nameUpdateBtn) setRequestUser(prev => ({ ...prev, name: user.name }));
    }, [nameUpdateBtn, user.name]);

    useEffect(() => {
        if (!phoneUpdateBtn) {
            setRequestUser(prev => ({ ...prev, phone: user.phone }));
            setClickAuthBtn(false);
            setAuthVerifyNumber("");
        }
    }, [phoneUpdateBtn, user.phone]);
    
    useEffect(() => {
        if (!emailUpdateBtn) setRequestUser(prev => ({ ...prev, email: user.email || "" }));
    }, [emailUpdateBtn, user.email]);

    useEffect(() => {
        getClassAndImage();
    }, []);

    return (
        loading ? <Loading /> :
        <FlexWrapR>
            <RowContentLeftWrap>
                <div className="file-wrap">
                    <ImageOneWrap onClick={handleImageFileClick}>
                        <img className="preview-image" srcSet={requestUser.base64_list.length > 0 ? requestUser.base64_list[0] : userMainImageUrl} alt="user_image"/>
                        <img className="carema-icon" src="/image/icon/camera-background.svg" alt="camera"/>
                        <input
                            type="file"
                            name="file"
                            onChange={(e) => onImageChange(e)}
                            accept=".jpg, .png, .jpeg"
                            style={{display: "none"}}
                            ref={imageInput}
                            multiple
                        />
                    </ImageOneWrap>
                </div>
                <FlexWrapR $justifyContent="center" style={{marginTop: '1rem'}}>
                    <SolidPrimarySubBtn onClick={updateUserImageInfo} disabled={!imageUpdateBtn} >저장</SolidPrimarySubBtn>
                    <OutlinePrimaryBtn onClick={cancleImageChange}>취소</OutlinePrimaryBtn>
                </FlexWrapR>
            </RowContentLeftWrap>
            <RowContentRightWrap>

                <InputWrapR>
                    <InputWrapC>
                        <label>이름</label>
                        <InputWrapR>
                            <input type="text" name="name" value={aesCBCDecrypt(requestUser.name)} onChange={handleInputChange}
                                placeholder="이름 입력" readOnly={!nameUpdateBtn} />
                            {!nameUpdateBtn ? 
                                <OutlinePrimaryBtn className="little-btn" onClick={() => setNameUpdateBtn(true)}>수정</OutlinePrimaryBtn>
                                : 
                                <InputWrapR $justifyContent="flex-end" style={{width: 'auto'}}>
                                    <SolidPrimarySubBtn className="little-btn" onClick={updateUserNameInfo}>저장</SolidPrimarySubBtn>
                                    <OutlinePrimaryBtn className="little-btn" onClick={() => setNameUpdateBtn(false)}>취소</OutlinePrimaryBtn>
                                </InputWrapR>
                            }
                        </InputWrapR>
                    </InputWrapC>
                </InputWrapR>

                <InputWrapR>
                    <InputWrapC>
                        <label>아이디</label>
                        <input type="text" name="login_id" value={user.login_id} readOnly />
                    </InputWrapC>
                </InputWrapR>

                <InputWrapR>
                    <InputWrapC>
                        <label>생년월일</label>
                        <input type="text" name="resident_number" value={user.resident_number ? aesCBCDecrypt(user.resident_number) : ""} readOnly />
                    </InputWrapC>
                </InputWrapR>

                <InputWrapR>
                    <InputWrapC>
                        <label>휴대폰</label>
                        <InputWrapC>
                            <InputWrapR>
                                <input type="text" name="phone" value={aesCBCDecrypt(requestUser.phone)} onChange={handlePhoneChange}
                                    placeholder="연락처 입력('-'없이 숫자만 입력)" readOnly={!phoneUpdateBtn || clickAuthBtn} />
                                {!phoneUpdateBtn ? 
                                    <OutlinePrimaryBtn className="little-btn" onClick={() => setPhoneUpdateBtn(true)}>수정</OutlinePrimaryBtn>
                                    : 
                                    <InputWrapR $justifyContent="flex-end" style={{width: 'auto'}}>
                                        <SolidPrimarySubBtn className="little-btn" onClick={updateUserPhoneInfo} disabled={!clickAuthBtn} >저장</SolidPrimarySubBtn>
                                        <OutlinePrimaryBtn className="little-btn" onClick={() => setPhoneUpdateBtn(false)}>취소</OutlinePrimaryBtn>
                                    </InputWrapR>
                                }
                            </InputWrapR>
                            {phoneUpdateBtn &&
                            <>
                                <InputWrapR>
                                    <input type="text" name="authNumber" value={authVerifyNumber} onChange={handleOnChange}
                                        placeholder="인증번호 입력" />
                                    <InputWrapR $justifyContent="flex-end" style={{width: 'auto', whiteSpace: 'nowrap'}}>
                                        <SolidPrimarySubBtn onClick={smsRequest}>인증번호 요청</SolidPrimarySubBtn>
                                    </InputWrapR>
                                </InputWrapR>
                                <InputWrapR $gap="2rem" style={{paddingLeft: '1rem'}}>
                                    {clickAuthBtn && <p className="text-red">{mins} : {sec}</p>}
                                    {isFail && <p className="text-red">인증번호를 다시 받아주세요.</p>}
                                </InputWrapR>
                            </>
                            }
                        </InputWrapC>
                    </InputWrapC>
                </InputWrapR>
                <InputWrapR>
                    <InputWrapC>
                        <label>이메일</label>
                        <InputWrapR>
                            <input type="text" name="email" value={requestUser.email ? aesCBCDecrypt(requestUser.email) : ""} onChange={handleInputChange}
                                placeholder="이메일 주소 입력" readOnly={!emailUpdateBtn} />
                            {!emailUpdateBtn ? 
                                <OutlinePrimaryBtn className="little-btn" onClick={() => setEmailUpdateBtn(true)}>수정</OutlinePrimaryBtn>
                                : 
                                <InputWrapR $justifyContent="flex-end" style={{width: 'auto'}}>
                                    <SolidPrimarySubBtn className="little-btn" onClick={updateUserEmailInfo}>저장</SolidPrimarySubBtn>
                                    <OutlinePrimaryBtn className="little-btn" onClick={() => setEmailUpdateBtn(false)}>취소</OutlinePrimaryBtn>
                                </InputWrapR>
                            }
                        </InputWrapR>
                    </InputWrapC>
                </InputWrapR>
                {user_role === ROLE_TEACHER &&
                    <InputWrapR>
                        <InputWrapC>
                            <label>담당반</label>
                            <input type="text" name="email" value={userTeamClass || "담당반을 지정해주세요"} placeholder="담당반을 지정해주세요" disabled />
                        </InputWrapC>
                    </InputWrapR>
                }
                {user_role !== ROLE_DIRECTOR &&
                    <InputWrapC>
                        <InputWrapR $justifyContent="flex-end" className="delete_id_btn">
                            <NoLineRedBtn onClick={() => setShowInput(prev => !prev)}>회원탈퇴</NoLineRedBtn>
                        </InputWrapR>
                        {showInput &&
                            <InputWrapR $alignItems="center">
                                <InputStyle
                                    type={!newEyeOnOff ? 'password' : 'text'}
                                    name="password"
                                    value={loginUserObj.login_pw}
                                    onChange={handlePwChange}
                                    onKeyDown={handleActiveEnter}
                                    maxLength={16}
                                    placeholder="탈퇴를 원하시면 비밀번호를 입력 후 탈퇴버튼을 눌러주세요"
                                />
                                <div className='eye-on-off delect-id-input' onClick={() => setNewEyeOnOff(prev => !prev)}>
                                    {!newEyeOnOff ? <img src="/image/icon/eye_visible.svg" alt="eye_visible" /> : <img src="/image/icon/eye_invisible.svg" alt="eye_invisible" />}
                                </div>
                                <OutlinePrimaryBtn className="little-btn" onClick={handleDelectId} disabled={!loginUserObj.login_pw}>탈퇴</OutlinePrimaryBtn>
                            </InputWrapR>
                        }
                    </InputWrapC>
                }
            </RowContentRightWrap>
        </FlexWrapR>
    );
}
export const Profile = () => {

    //상단 메뉴 탭
    const [activeMenu, setActiveMenu] = useState('info');
    
    //상단 탭 변경
    const handleJoinType = (type: string) => {
        setActiveMenu(type);
    };

    return (
        <>
            <PageHeaderTitleButtonStyle>
                <p className="header-title">내 정보 수정</p>
            </PageHeaderTitleButtonStyle>

            <PageArticleWrap>
                <article className="list-content-container" style={{gap: '1rem'}}>
                    {/* 기본 정보 / 비밀번호 변경 */}
                    <MenuToggleWrap>
                        <NoLinePrimaryBtn
                            type="button"
                            className={`text-btn ${ activeMenu === "info" ? "active" : "" }`}
                            onClick={() => handleJoinType("info")}
                        >
                            <p>기본 정보</p>
                        </NoLinePrimaryBtn>
                        <NoLinePrimaryBtn
                            type="button"
                            className={`text-btn ${ activeMenu === "pw" ? "active" : "" }`}
                            onClick={() => handleJoinType("pw")}
                        >
                            <p>비밀번호 변경</p>
                        </NoLinePrimaryBtn>
                    </MenuToggleWrap>
                    {activeMenu === 'info' ?
                        <UserInfoViewer />
                        : <UserChangePwViewer />
                    }
                </article>
            </PageArticleWrap>
        </>
    );
}
